exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Timeline{padding:.5rem 0 5rem}.Timeline .primary-view{width:100%;max-width:768px;margin:0 auto}.Timeline .status-message{font-family:Lato,sans-serif;font-weight:400;text-align:center;position:absolute;top:50%;left:0;right:0;margin-top:-2.85rem;line-height:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Timeline.scss
// module id = 234
// module chunks = 0